import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import InfoIcon from 'dibs-vg/dist/react/info-circle';
import styles from './styles/CartShippingTooltip.scss';

class CartShippingTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: false,
        };

        this.handleMouseOut = this.handleMouseOut.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
    }
    handleMouseOut() {
        this.setState({ isVisible: false });
    }

    handleMouseOver() {
        this.setState({ isVisible: true });
    }

    render() {
        const { item } = this.props;
        const { isVisible } = this.state;

        return (
            <div
                className={styles.wrapper}
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
                data-tn="shipping-tooltip"
            >
                <InfoIcon className={styles.icon} />
                <Tooltip isVisible={isVisible} direction="left" dataTn="quote-needed-tooltip">
                    <p className={styles.p}>
                        <FormattedMessage
                            id="CartShippingTooltip.message1"
                            defaultMessage="Most {vertical, select, art {gallery} other {dealer}} prefer to quote shipping after they know your location. The quote will be emailed for your approval 24-48 hours after you check out."
                            values={{ vertical: item.vertical }}
                        />
                    </p>
                    <p className={styles.p}>
                        <FormattedMessage
                            id="CartShippingTooltip.message2"
                            defaultMessage="We know this is unusual, but if shipping is additional, you may arrange your own shipping, or easily cancel the purchase."
                        />
                    </p>
                </Tooltip>
            </div>
        );
    }
}

CartShippingTooltip.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(CartShippingTooltip, {
    item: graphql`
        fragment CartShippingTooltip_item on Item {
            vertical
        }
    `,
});
